'use client';

import React from 'react';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import Blog from '@/features/Blog/Blog';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { FAQ } from '@/features/FAQ/FAQ';
import { Intro } from '@/features/Intro/Intro';
import { ListItems } from '@/features/ListItems/ListItems';
import { OurReviews } from '@/features/OurReviews/OurReviews';
import { Testimonals } from '@/features/Testimonals/Testimonals';
import {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  industries,
  intro,
  reviews,
  testimonals,
} from '@/lib/industries/property_maintenance';

const PropertyMaintenance = () => {
  return (
    <>
      <Intro withVideo={false} imageSrc={intro.imageSrc.src} item={intro} />

      <Section>
        <Container>
          <FullArticle item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Discover the convenience of managing all your property maintenance needs in one place – without spending a dime.`}
          subTitle="Ready to Enhance Your Property Maintenance?"
          thirtTitle=""
          listItems={[]}
        />
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <Container>
          <OurReviews item={reviews} />
        </Container>
      </Section>

      <Section>
        <Container>
          <FullArticle item={fullArticle2} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Take The Next Step Towards Operational Excellence With Orcatec`}
          subTitle="Ready to Revolutionize Your Maintenance Management?"
          listItems={[
            { title: 'Free version' },
            { title: 'Onboarding and support' },
            { title: 'Data migration' },
            { title: '24/7 customer service' },
          ]}
        />
      </Section>

      <Section>
        <Container>
          <Testimonals title="Our Testimonials" items={testimonals} />
        </Container>
      </Section>

      <Container>
        <Section title="FAQ">
          <FAQ items={faq} />
        </Section>
      </Container>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <Blog />
          </Section>
        </Container>
      </BlogLayout>

      <Container>
        <Section title={industries.title} description={industries.description}>
          <ListItems {...industries} />
        </Section>
      </Container>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default PropertyMaintenance;
